import React, { useEffect, useState } from "react";
import { WO_TYPE_LIST } from "src/Common/contants";

const CalendarWeekTicket = ({ ticket }) => {
  const [WOStatus, setWOStatus] = useState(ticket.status);

  useEffect(() => {
    const today = new Date();
    const startDate = new Date(ticket.startDate);
    if (ticket.status === 100) setWOStatus("closed");
    if (startDate < today && ticket.status !== 100) {
      setWOStatus("open");
    } else if (startDate > today) {
      setWOStatus("scheduled");
    }
  }, [ticket.status, ticket.startDate]);
  const getTicketCardIcon = (status) => {
    if (status === "open") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5335 2.5C6.51509 2.5 6.50016 2.51492 6.50016 2.53333V3.5H9.50016V2.53333C9.50016 2.51492 9.48524 2.5 9.46683 2.5H6.5335ZM10.5002 3.5V2.53333C10.5002 1.96264 10.0375 1.5 9.46683 1.5H6.5335C5.9628 1.5 5.50016 1.96264 5.50016 2.53333V3.5H2.9335C1.7737 3.5 0.833496 4.4402 0.833496 5.6V11.7333C0.833496 12.8931 1.7737 13.8333 2.9335 13.8333H13.0668C14.2266 13.8333 15.1668 12.8931 15.1668 11.7333V5.6C15.1668 4.4402 14.2266 3.5 13.0668 3.5H10.5002ZM2.9335 4.5C2.32598 4.5 1.8335 4.99249 1.8335 5.6V8.16667H6.16683V7.86667C6.16683 7.29597 6.62947 6.83333 7.20016 6.83333H8.80016C9.37086 6.83333 9.8335 7.29597 9.8335 7.86667V8.16667H14.1668V5.6C14.1668 4.99249 13.6743 4.5 13.0668 4.5H2.9335ZM14.1668 9.16667H9.8335V9.46667C9.8335 10.0374 9.37086 10.5 8.80016 10.5H7.20016C6.62947 10.5 6.16683 10.0374 6.16683 9.46667V9.16667H1.8335V11.7333C1.8335 12.3408 2.32598 12.8333 2.9335 12.8333H13.0668C13.6743 12.8333 14.1668 12.3408 14.1668 11.7333V9.16667ZM7.16683 9.46667C7.16683 9.48508 7.18175 9.5 7.20016 9.5H8.80016C8.81857 9.5 8.8335 9.48508 8.8335 9.46667V7.86667C8.8335 7.84826 8.81857 7.83333 8.80016 7.83333H7.20016C7.18175 7.83333 7.16683 7.84826 7.16683 7.86667V9.46667Z"
            fill="#010D3D"
          />
        </svg>
      );
    } else if (status === "closed") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_5515_5354)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.00016 1.8335C4.59441 1.8335 1.8335 4.59441 1.8335 8.00016C1.8335 11.4059 4.59441 14.1668 8.00016 14.1668C11.4059 14.1668 14.1668 11.4059 14.1668 8.00016C14.1668 4.59441 11.4059 1.8335 8.00016 1.8335ZM0.833496 8.00016C0.833496 4.04212 4.04212 0.833496 8.00016 0.833496C11.9582 0.833496 15.1668 4.04212 15.1668 8.00016C15.1668 11.9582 11.9582 15.1668 8.00016 15.1668C4.04212 15.1668 0.833496 11.9582 0.833496 8.00016ZM10.9574 5.5933C11.1822 5.7538 11.2342 6.06608 11.0737 6.29078L7.74036 10.9574C7.65493 11.077 7.52121 11.153 7.37474 11.1651C7.22826 11.1772 7.08387 11.1243 6.97994 11.0204L4.97994 9.02038C4.78468 8.82512 4.78468 8.50854 4.97994 8.31328C5.17521 8.11801 5.49179 8.11801 5.68705 8.31328L7.26969 9.89592L10.26 5.70954C10.4205 5.48484 10.7327 5.43279 10.9574 5.5933Z"
              fill="#16A81C"
            />
          </g>
          <defs>
            <clipPath id="clip0_5515_5354">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    } else if (status === "scheduled") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.40007 2.26373C5.23192 2.26373 2.66363 4.83202 2.66363 8.00016C2.66363 11.1683 5.23192 13.7366 8.40007 13.7366C11.5682 13.7366 14.1365 11.1683 14.1365 8.00016C14.1365 4.83202 11.5682 2.26373 8.40007 2.26373ZM1.7334 8.00016C1.7334 4.31826 4.71817 1.3335 8.40007 1.3335C12.082 1.3335 15.0667 4.31826 15.0667 8.00016C15.0667 11.6821 12.082 14.6668 8.40007 14.6668C4.71817 14.6668 1.7334 11.6821 1.7334 8.00016ZM8.40007 3.81412C8.65694 3.81412 8.86518 4.02236 8.86518 4.27923V7.63701L10.9935 8.16909C11.2427 8.23139 11.3942 8.48392 11.3319 8.73313C11.2696 8.98233 11.0171 9.13385 10.7679 9.07155L8.38121 8.47488C8.11894 8.40931 7.93495 8.17367 7.93495 7.90332V4.27923C7.93495 4.02236 8.14319 3.81412 8.40007 3.81412Z"
            fill="white"
          />
        </svg>
      );
    }
  };

  const getTicketCardBackgroundColor = (status) => {
    if (status === "closed") return "bg-[#FFF]";
    if (status === "open") return "bg-[#FFFBF2]";
    if (status === "scheduled") return "bg-[#ECF4FF]";
  };

  const getTicketCardBorderColor = (status) => {
    if (status === "closed") return "border border-[#16A81C]";
    return;
  };

  const getTicketCardIconBackgroundColor = (status) => {
    if (status === "closed") return "bg-[#FFF]";
    if (status === "open") return "bg-[#FFEC40]";
    if (status === "scheduled") return "bg-[#408CFD]";
  };
  return (
    <div
      className={`flex flex-row p-2 space-x-2 rounded-[4px] shadow-ticekt-card ${getTicketCardBackgroundColor(
        WOStatus
      )} ${getTicketCardBorderColor(WOStatus)}`}
    >
      <div
        className={`flex flex-col items-center justify-center w-6 h-6 shrink-0 rounded-full gap-[10px] ${getTicketCardIconBackgroundColor(
          WOStatus
        )}`}
      >
        {getTicketCardIcon(WOStatus)}
      </div>
      <div className="flex flex-col space-y-[2px]">
        <span className="text-[12px] text-[#404A6E]">#{ticket.number}</span>
        <h4 className="text-[12px] text-[#010D3D]">{ticket.company}</h4>
        <h5 className="text-[10px] text-[#0065FD]">
          {WO_TYPE_LIST[ticket.type]}
        </h5>
      </div>
    </div>
  );
};

export default CalendarWeekTicket;
